(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/calculator-excess
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @overview Calculates a new total from subtotal plus additional percentage.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("calculator-excess") === undefined) {
    class CalculatorExcess extends HTMLElement {
        constructor(){
            super();
            this.inputSubtotal = this.querySelector("[data-calculator-excess-subtotal]");
            this.inputPercent = this.querySelector("[data-calculator-excess-percent]");
            this.inputTotal = this.querySelector("[data-calculator-excess-total]");
            this.inputSubtotal.addEventListener("input", this.updateEvent.bind(this), false);
            this.inputPercent.addEventListener("input", this.updateEvent.bind(this), false);
        }
        updateEvent() {
            const total = this.inputSubtotal.valueAsNumber + this.inputSubtotal.valueAsNumber * (this.inputPercent.valueAsNumber / 100);
            if (isNaN(total)) return false;
            this.inputTotal.value = total;
            this.inputTotal.dispatchEvent(new Event("input"));
        }
    }
    customElements.define("calculator-excess", CalculatorExcess);
}



})();
